import WishlistItemDash from './WishlistItemDash'
import classes from "./WishlistItemDash.module.css";

const Wishlist = () => {
  return (

      <WishlistItemDash />

  )
}
export default Wishlist
